<template>
    <div class="relative">
      <div class="relative d-inline">
        <input class="search"
          type="text"
          :placeholder="placeholder"
          v-model="keyword"
          @input="isSearchEmpty()"
          @keyup.enter="search()">
      </div>
      <div class="pointer-events-none absolute pin-y pin-l pl-3 flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="fill-current pointer-events-none text-grey-dark w-4 h-4">
          <path d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"></path>
        </svg>
      </div>
      <div class="absolute pin-r pin-y pr-3 flex items-center" style="display: none;">
        <span class="no-lineheight text-xl text-grey-darker hover:text-grey-darkest font-semibold cursor-pointer">×</span>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Zoeken..',
      required: false
    },
    value: {
      type: String,
      default: '',
      required: false
    }
  },
  data() {
    return {
      keyword: this.value,
      searched: false
    };
  },
  mounted() {
    if (this.value.length) {
      this.searched = true;
    }
  },
  methods: {
    isSearchEmpty() {
      if (this.searched && this.keyword.length == 0) {
        this.$emit('searched', null);
      }
    },
    search() {
      if (this.keyword.length < 3) return;

      this.searched = true;
      this.$emit('searched', this.keyword);
    }
  }
};
</script>

<style>
.search {
  display: block;
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  background-color: #fff;
  color: #3d4852;
  font-size: 0.875rem;
  line-height: 1.5;
  appearance: none;
}
.search:focus {
  z-index: 1;
  box-shadow: 0 0 5px #1f9d55;
}
</style>
